import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const SalesPolicy = () => {
  return (
    <div>
      <Navbar/>
      SalesPolicy
      <Footer/>
    </div>
  )
}

export default SalesPolicy
